import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Inbox16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.80903 1.75C3.33556 1.75 2.90273 2.0175 2.69099 2.44098L0.381967 7.05902C0.295182 7.23259 0.25 7.42398 0.25 7.61803V13C0.25 13.6904 0.809643 14.25 1.5 14.25H14.5C15.1904 14.25 15.75 13.6904 15.75 13V7.61803C15.75 7.42398 15.7048 7.23259 15.618 7.05902L13.309 2.44098C13.0973 2.0175 12.6644 1.75 12.191 1.75H3.80903ZM2.21353 6.75L3.96353 3.25H12.0365L13.7865 6.75H11C10.8011 6.75 10.6103 6.82902 10.4697 6.96968L9.18934 8.25003L6.81066 8.25L5.53033 6.96967C5.38968 6.82902 5.19891 6.75 5 6.75H2.21353ZM1.75 8.25V12.75H14.25V8.25H11.3107L10.0303 9.53036C9.88968 9.67102 9.69891 9.75004 9.49999 9.75003L6.49999 9.75C6.30108 9.75 6.11032 9.67098 5.96967 9.53033L4.68934 8.25H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Inbox16.displayName = 'Inbox16';
export default Inbox16;
